import type { ChartOptions } from '/#/components/base/chart/chart'

const { colors } = useThemeColors()
const { getColorScales } = useThemeColors()

export const DEFAULT_CHART_BORDER_WIDTH = 4
export const DEFAULT_CHART_BORDER_RADIUS = 4
export const DEFAULT_CHART_BAR_WIDTH = 16

export const DEFAULT_CHART_OPTIONS: ChartOptions = {
  chart: {
    style: {
      fontFamily: 'Forza',
    },
    backgroundColor: 'transparent',
  },
  accessibility: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  title: {
    text: undefined,
  },
  colors: getColorScales('danger', 300, 900),
  xAxis: {
    gridLineWidth: 0,
    gridLineDashStyle: 'Dash',
    gridLineColor: colors.slate[200],
    lineColor: colors.slate[200],
    labels: {
      enabled: true,
    },
  },
  yAxis: {
    gridLineWidth: 1,
    gridLineDashStyle: 'Dash',
    gridLineColor: colors.slate[200],
    title: {
      text: undefined,
    },
  },
  tooltip: {
    shadow: false,
    shared: false,
    style: {
      filter: 'drop-shadow(0 0 0.5rem rgba(0, 0, 0, 0.2))',
    },
    useHTML: true,
    formatter: function tooltipFormatter() {
      return `
      <div class="highcharts-custom-tooltip-wrapper">
        <span style="font-weight: bold">${this.series.name}</span>
        <div class="highcharts-custom-tooltip-point-wrapper">
          <span class="highcharts-custom-tooltip-point" style="background:${this.point.color}; border-radius: ${DEFAULT_CHART_BORDER_RADIUS}px"></span>
          <span>${this.series.name || 'Point'}: ${this.y}</span>
        </div>
      </div>`
    },
  },
  legend: {
    enabled: true,
    align: 'right',
    symbolWidth: 16,
    symbolHeight: 12,
    symbolRadius: DEFAULT_CHART_BORDER_RADIUS,
  },
  plotOptions: {
    column: {
      borderRadiusTopLeft: DEFAULT_CHART_BORDER_RADIUS,
      borderRadiusTopRight: DEFAULT_CHART_BORDER_RADIUS,
      borderRadiusBottomLeft: DEFAULT_CHART_BORDER_RADIUS,
      borderRadiusBottomRight: DEFAULT_CHART_BORDER_RADIUS,
      pointWidth: DEFAULT_CHART_BAR_WIDTH,
      borderWidth: DEFAULT_CHART_BORDER_WIDTH,
      borderColor: 'white',
      dataLabels: {
        enabled: false,
      },
    },
    solidgauge: {
      // @ts-ignore This is actually a feature within the chart, it exists in their demos but produces a type error
      borderRadius: DEFAULT_CHART_BORDER_RADIUS,
      borderWidth: 0,
      radius: '100%',
      innerRadius: '70%',
      dataLabels: {
        y: -10,
        borderWidth: 0,
        useHTML: true,
      },
    },

    map: {
      color: colors.slate[500],
      borderWidth: 0.0,
      borderColor: colors.slate[500],
      nullColor: colors.slate[200],

      states: {
        hover: {
          color: colors.slate[500],
          borderWidth: 0.0,
          borderColor: colors.slate[500],
        },
        inactive: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
    },
    bar: {
      borderRadiusBottomLeft: DEFAULT_CHART_BORDER_RADIUS,
      borderRadiusBottomRight: DEFAULT_CHART_BORDER_RADIUS,
      borderRadiusTopLeft: DEFAULT_CHART_BORDER_RADIUS,
      borderRadiusTopRight: DEFAULT_CHART_BORDER_RADIUS,
    },
  },
}
